import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GithubAiAccesses } from "./accesses.ts";
import { GithubAiComponents } from "./components.ts";
import { GithubAiIconUrl } from "./icon.ts";

const GithubAiFilters = {
  organization: { keys: ["name"] },
  repository: { keys: ["name"] },
  // Matches the raw "<permission>:<level>" verb tokens. Rule filter values compile to
  // regular expressions, so rules can scope by permission ("contents:.*"), by level
  // (".*:read"), or exactly ("contents:write").
  policy: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type GithubAiFilters = typeof GithubAiFilters;

export const GithubAiRegistration = Registration({
  accesses: GithubAiAccesses,
  category: "resource",
  components: GithubAiComponents,
  docs: {
    install: "agentic-gateway/mcp-server/github",
    request: "agentic-gateway/requesting-access",
  },
  filters: GithubAiFilters,
  itemKind: "Organization",
  label: "GitHub App",
  logoUrl: GithubAiIconUrl,
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "credential" }],
});

registerIntegration("github-ai", GithubAiRegistration);
